export interface WelcomeScreenConfig {
  background: string;
  welcomeBanner: string;
  welcomeDescription: string;
  footerText: string;
}

const defaultConfig: WelcomeScreenConfig = {
  background: '/assets/layout-own-ai-dominate-v2/jia/welcome/main-image.png',
  welcomeBanner: '/assets/layout-own-ai-dominate-v2/welcome/banner-v1.png',
  welcomeDescription:
    'She doesn’t flirt. She commands. If she likes your answers — she’ll message first',
  footerText: 'Ready to be tested',
};

const welcomeV2Config: WelcomeScreenConfig = {
  background: '/assets/layout-own-ai-dominate-v2/jia/welcome/main-image.png',
  welcomeBanner: '/assets/layout-own-ai-dominate-v2/welcome/banner-v2.png',
  welcomeDescription:
    'I’m not here to please you. Unless you beg properly. Shall we begin shaping your mistress?',
  footerText: 'Yes, Mistress',
};

const welcomeLucyConfig: WelcomeScreenConfig = {
  background: '/assets/layout-own-ai-dominate-v2/lucy/welcome/main-image.png',
  welcomeBanner: '/assets/layout-own-ai-dominate-v2/welcome/banner-v2.png',
  welcomeDescription:
    'I’m not here to please you. Unless you beg properly. Shall we begin shaping your mistress?',
  footerText: 'Yes, Mistress',
};

export const getWelcomeScreenConfig = (
  notes?: string[],
): WelcomeScreenConfig => {
  if (notes?.includes('lucy')) {
    return welcomeLucyConfig;
  }
  if (notes?.includes('welcome-v2')) {
    return welcomeV2Config;
  }
  return defaultConfig;
};
